export const transactionStatusMap = {
    "-100": 'No transaction result received', //cashnet code
    "-9": 'System Error',
    "-1": 'No Response from Credit Company',
    "0": 'Approved',
    "1": 'Transaction Denied',
    "2": 'User Canceled',
    "4": 'System down for maintenance', //cashnet code
    "8": 'Transaction Not Approved'

}

export const transactionStatusOptions = [
    {value: -100, label: 'No transaction result received'}, //cashnet code
    {value: -9, label: 'System Error'},
    {value: -1, label: 'No Response from Credit Company'},
    {value: 0, label: 'Approved'},
    {value: 1, label: 'Transaction Denied'},
    {value: 2, label: 'User Canceled'},
    {value: 4, label: 'System down for maintenance'}, //cashnet code
    {value: 8, label: 'Transaction Not Approved'}

]

export default transactionStatusMap